import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import 'react-image-lightbox/style.css';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { Title, TitleSymbol, Wrapper, Gallery, ImageWrapper, GalleryImage } from './ConferencePhotoGalleryStatic.elements';
import { getApiURL } from '../../constants';


interface ConferenceProps {
    conf?: IConferenceItem;
}

const ConferencePhotoGalleryTemplate: FC<ConferenceProps> = ({ conf }) => {
    const { t } = useTranslations();

    const [images, setImages] = useState([]);

    useEffect(() => {
        if (conf?.conference?.static_gallery) {
            setImages(conf?.conference?.static_gallery);
        }
    }, [conf?.conference?.static_gallery]);

    return (
        <>
            {images?.length > 0 && (
                <Gallery>
                    {images?.map((photo, index) => (
                        <ImageWrapper key={`image${photo}${index}`}>
                            <GalleryImage
                                src={`${getApiURL()}/media/conference/static-gallery/${photo}`} key={index}
                            />
                        </ImageWrapper>
                    ))}
                </Gallery>
            )}
        </>
    );
};

export default ConferencePhotoGalleryTemplate;
